
import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import { i18n } from './utils/locales/default';
import Vuelidate from 'vuelidate';
import VueResource from 'vue-resource'
import App from './App.vue';
import router from './router';
import moment from 'moment-timezone';
import Croppa from 'vue-croppa';
import currency from 'v-currency-field';
import "vue-swatches/dist/vue-swatches.min.css";
import 'vue-croppa/dist/vue-croppa.css';
import 'v-currency-field/dist/index.css';

const routeAuth = require('./router/routeAuth');

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(Croppa);
Vue.use(currency);

Vue.http.options.root = process.env.VUE_APP_ROOT_API || 'http://localhost:9090/api';

Vue.http.interceptors.push((request, next) => {
    const token = localStorage.getItem("supplierToken")
    if (token) {
        request.headers.set('Authorization', 'Bearer ' + token);
    }

    next((response) => {
        if (router.currentRoute.name === 'login') return;
        if (response.status === 403) {
            events.$emit('closeSession');
        } else if (response.status === 401) {
            events.$emit('closeSession', router.currentRoute.path);
        }
    });
});

export const headers = Vue.http.headers.common;

export const events = new Vue();

routeAuth.setEvents(events);
routeAuth.applyRules(router);

new Vue({
    i18n,
    router,
    render: h => h(App)
}).$mount('#app')
